import { takeEvery, put } from "redux-saga/effects";

import { davInstance } from "axios-config";
import * as types from "./types";
import * as actions from "store/actions";
// import Encrypt from "crypto-js";
import { aesEncryption, decryptData, scrollToView } from "utils";
import { CONTENT, NOTIFICATIONS } from "consts";

export function* loginUserStart(action) {
  // TODO: enable encryption after dav api is updated
  const encryptDetails = {
    emailid: action.details.emailid,
    // aesEncryption({
    //   text: action.details.emailid,
    //   encrypt: Encrypt.AES.encrypt,
    //   md5: Encrypt.MD5,
    //   secret: process.env.REACT_APP_SECRET_KEY,
    // }),
    password: action.details.password
    // aesEncryption({
    //   text: action.details.password,
    //   encrypt: Encrypt.AES.encrypt,
    //   md5: Encrypt.MD5,
    //   secret: process.env.REACT_APP_SECRET_KEY,
    // }),
  };

  try {
    if (action.passwordAuth) yield put(actions.reEnterPasswordStart());
    const response = yield davInstance.post(
      "/login/?recaptcharesp=" + action.details.recaptcharesp,
      encryptDetails
    );

    if (response.data.code === 200) {
      yield put(actions.updateProfileDetails(response.data.message.user));
      yield put(actions.fetchAllPlansStart());
      if (response.data.message.user.accountStatus !== "Y") {
        if (response.data.message.user.accountStatus === "C")
          yield put(actions.loginUserFailed({ accountCancelled: true }));
        else if (response.data.message.user.accountStatus === "B")
          yield put(actions.loginUserFailed({ accountBlocked: true }));
        else yield put(actions.loginUserFailed());
      } else yield put(actions.loginUserSuccess(response.data));
    }
    if (response.data.code === 404 || response.data.code === 500) {
      scrollToView("notifyPass");
      yield put(actions.loginUserFailed());
    }
  } catch (error) {
    console.log(error);
    yield put(actions.loginUserFailed());
  }
}

export function* logoutUser(params) {
  yield takeEvery(types.LOGOUT_USER, action => {
    params.wsConnection.close();
  });
}

export function* logoutLog(action) {
  try {
    if (action.flag) {
      yield davInstance.post(
        "/audit/save",
        {
          activityName: "USER_LOGOUT",
          description: CONTENT.logoff.savelogs
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );
    }

    yield put(actions.cleanLocalStorage());
  } catch (error) {
    yield put(actions.cleanLocalStorage());
    console.log(error);
  }
}

export function* logoutStart(action) {
  try {
    if (action.flag) {
      const response = yield davInstance.post("/login/logout", null);
    }
    if (action.redirect === "360") {
      window.location = "https://www.idrive360.com/enterprise/logout";
    } else if (action.redirect === "ibackup") {
      window.location = "https://www5.ibackup.com/newibackup/logout";
    } else if (action.redirect === "idrive") {
      window.location = "https://www.idrive.com/idrive/login/signout";
    }
    yield put(actions.cleanLocalStorage());
  } catch (error) {
    yield put(actions.cleanLocalStorage());
    console.log(error);
  }
}

export function* createAccountStart(action) {
  if (action.logout) yield put(actions.logoutUser());
  const encryptDetails = {
    ...action.details,
    emailid: action.details.emailid,
    // aesEncryption({
    //   text: action.details.emailid,
    //   encrypt: Encrypt.AES.encrypt,
    //   md5: Encrypt.MD5,
    //   secret: process.env.REACT_APP_SECRET_KEY,
    // }),
    password: action.details.password
    // aesEncryption({
    //   text: action.details.password,
    //   encrypt: Encrypt.AES.encrypt,
    //   md5: Encrypt.MD5,
    //   secret: process.env.REACT_APP_SECRET_KEY,
    // }),
  };

  try {
    const response = yield davInstance.post(
      "/register/?recaptcharesp=" + action.details.recaptcharesp,
      encryptDetails
    );
    if (response.data.code === 200) {
      yield put(actions.startRedirect(true));
      yield put(actions.updateProfileDetails(response.data.message.user));
      yield put(
        actions.createAccountSuccess(
          response.data.message,
          action.details.emailid
        )
      );
      if (["windows"].includes(window.OSName))
        yield put(actions.downloadClientSetupStart());
    }
    if (response.data.code === 500) {
      scrollToView("notifyPass");
      action.details.message = response.data.message.message;
      yield put(
        actions.createAccountFailure(action.details, action.details.emailid)
      );
    }
    if (response.data.code === 400 || response.data.code === 404) {
      scrollToView("notifyPass");
      action.details.message = response.data.message.message;
      yield put(
        actions.createAccountFailure(action.details, action.details.emailid)
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* checkAuthStart(action) {
  try {
    const response = yield davInstance.post("token/validate/web", null);

    if (response.data.code === 200) {
      if (response.data.message.accountStatus !== "Y") {
        if (response.data.message.origin === "360")
          yield put(actions.logoutUser(false, "360"));
        else yield put(actions.logoutUser());
      } else {
        yield put(actions.updateProfileDetails(response.data.message));
        yield put(actions.checkAuthSuccess(response.data));
        yield put(actions.fetchAllPlansStart());
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* passwordResetStart(action) {
  try {
    const response = yield davInstance.post(
      "user/password/reset?recaptcharesp=" + action.token,
      null,
      {
        params: {
          emailId: action.emailid
        }
      }
    );

    if (response.data.code === 200)
      yield put(actions.passwordResetSuccess(NOTIFICATIONS.auth.resetPassword));
    else {
      yield put(
        actions.passwordResetFailure(
          response.data.message.message
            ? response.data.message.message
            : response.data.message
        )
      );
    }
    scrollToView("notifyPass");

    // yield put(actions.checkAuthSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

export function* passwordValidateStart(action) {
  try {
    const response = yield davInstance.post("user/validatePwdToken", null, {
      params: {
        token: action.token
      }
    });
    if (response.data.code === 200) {
      yield put(actions.passwordValidateSuccess(response.data.message));
    } else {
      if (action.logout) {
        yield put(actions.logoutUser());
        yield put(actions.passwordValidateFailure(response.data.message));
      } else {
        yield put(actions.passwordValidateFailure(response.data.message));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* updatePasswordAuthStart(action) {
  try {
    const response = yield davInstance.put(
      "user/password/updatepwd?recaptcharesp=" + action.details.recaptcharesp,
      null,
      {
        params: {
          password: action.details.password,
          confPassword: action.details.confPassword,
          token: action.details.token
        }
      }
    );
    if (response.data.code === 200)
      if (action.logout) {
        yield put(actions.logoutUser());
        yield put(actions.startRedirect(true));
        yield put(actions.updatePasswordAuthSuccess(response.data.message));
      } else {
        scrollToView("notifyPass");
        yield put(actions.startRedirect(true));
        yield put(actions.updatePasswordAuthSuccess(response.data.message));
      }
    else yield put(actions.updatePasswordAuthFailure(response.data.message));
  } catch (error) {
    console.log(error);
  }
}

export function* fetchAllClientsVersionStart(action) {
  try {
    const response = yield davInstance.get("/appversion/getAll");

    if (response.status === 200)
      yield put(
        actions.fetchAllClientsVersionSuccess(response.data, action.status)
      );
  } catch (error) {
    console.log(error);
  }
}

export function* updateClientVersionStart(action) {
  try {
    yield davInstance.put("appversion/update", action.data);
  } catch (error) {
    console.log(error);
  }
}

export function* addClientVersionStart(action) {
  try {
    yield davInstance.post("appversion/add", action.data);
  } catch (error) {
    console.log(error);
  }
}

export function* createSubUserStart(action) {
  if (action.logout) yield put(actions.logoutUser());
  try {
    const response = yield davInstance.post(
      "subUser/activateuser?recaptcharesp=" + action.data.recaptcharesp,
      action.data,
      {
        params: {
          token: action.data.token
        }
      }
    );

    if (response.data.code === 200) {
      // yield put(actions.startRedirect(true));

      yield put(actions.updateProfileDetails(response.data.message.user));
      yield put(actions.createAccountSuccess(response.data.message));

      yield put(actions.startRedirect(true));
      if (["windows"].includes(window.OSName))
        yield put(actions.downloadClientSetupStart());
    }
    if (response.data.code === 500) {
      action.data.message = response.data.message.message;
      yield put(
        actions.createAccountFailure(action.data, action.data.username)
      );
    }
    if (response.data.code === 400) {
      action.data.message = response.data.message.message;
      yield put(
        actions.createAccountFailure(action.data, action.data.username)
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* validateSubUserStart(action) {
  try {
    const response = yield davInstance.post(
      "subUser/validateSubUserToken",
      null,
      {
        params: {
          token: action.token
        }
      }
    );

    if (response.data.code === 200) {
      yield put(actions.validateSubUserSuccess(response.data.message));
    } else {
      if (action.logout) {
        yield put(actions.logoutUser());
        yield put(actions.validateSubUserFailure(response.data.message));
      } else {
        yield put(actions.validateSubUserFailure(response.data.message));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export function* fetchPromoDiscountStart(action) {
  try {
    const response = yield davInstance.get("getPromoDiscount", {
      params: {
        promocode: action.promo
      }
    });

    if (response.data.code === 200) {
      yield put(actions.fetchPromoDiscountSuccess(response.data.message));
    } else {
      yield put(actions.fetchPromoDiscountFailure(response.data.message));
    }
  } catch (error) {
    console.log(error);
  }
}

export function* createPromoAccountStart(action) {
  if (action.logout) yield put(actions.logoutUser());
  const encryptDetails = {
    ...action.details,
    emailid: action.details.emailid,
    // aesEncryption({
    //   text: action.details.emailid,
    //   encrypt: Encrypt.AES.encrypt,
    //   md5: Encrypt.MD5,
    //   secret: process.env.REACT_APP_SECRET_KEY,
    // }),
    password: action.details.password
    // aesEncryption({
    //   text: action.details.password,
    //   encrypt: Encrypt.AES.encrypt,
    //   md5: Encrypt.MD5,
    //   secret: process.env.REACT_APP_SECRET_KEY,
    // }),
  };

  try {
    const response = yield davInstance.post(
      "/promo/register/?recaptcharesp=" + action.details.recaptcharesp,
      encryptDetails,
      {
        params: {
          promocode: action.details.promo
        }
      }
    );
    if (response.data.code === 200) {
      yield put(actions.startRedirect(true));
      yield put(actions.updateProfileDetails(response.data.message.user));
      yield put(
        actions.createAccountSuccess(
          response.data.message,
          action.details.emailid
        )
      );
      if (["windows"].includes(window.OSName))
        yield put(actions.downloadClientSetupStart());
    }
    if (response.data.code === 500) {
      scrollToView("notifyPass");
      action.details.message = response.data.message.message;
      yield put(
        actions.createAccountFailure(action.details, action.details.emailid)
      );
    }
    if (response.data.code === 400) {
      scrollToView("notifyPass");
      action.details.message = response.data.message.message;
      yield put(
        actions.createAccountFailure(action.details, action.details.emailid)
      );
    }
  } catch (error) {
    console.log(error);
  }
}

export function* validate360Start(action) {
  if (action.logout) yield put(actions.logoutUser());
  try {
    const response = yield davInstance.post("/token/360/validate", null, {
      params: {
        token: action.token
      }
    });

    if (response.data.code === 200) {
      yield put(actions.updateProfileDetails(response.data.message.user));
      yield put(actions.startRedirect(true));
      if (action.redirect) {
        yield put(actions.createAccountSuccess(response.data.message));
        if (["windows"].includes(window.OSName))
          yield put(actions.downloadClientSetupStart());
      } else yield put(actions.loginUserSuccess(response.data));
    }
    if (response.data.code === 400 || response.data.code === 500) {
      yield put(actions.validate360Failure(response.data.message));
    }
  } catch (error) {
    console.log(error);
    yield put(actions.validate360Failure());
  }
}

export function* validateIbackupStart(action) {
  if (action.logout) yield put(actions.logoutUser());
  try {
    const response = yield davInstance.post("/token/ibackup/validate", null, {
      params: {
        token: action.token
      }
    });

    if (response.data.code === 200) {
      yield put(actions.updateProfileDetails(response.data.message.user));

      if (action.redirect) {
        yield put(actions.createAccountSuccess(response.data.message));
        yield put(actions.startRedirect(true));
        if (["windows"].includes(window.OSName))
          yield put(actions.downloadClientSetupStart("ibackup"));
      } else {
        yield put(actions.loginUserSuccess(response.data));
        yield put(actions.startRedirect(true));
      }
    }
    if (response.data.code === 400 || response.data.code === 500) {
      yield put(actions.validateIbackupFailure(response.data.message));
    }
  } catch (error) {
    console.log(error);
    yield put(actions.validateIbackupFailure());
  }
}
